module.exports = __webpack_public_path__ + "static/img/Visualization14.0afbcc03.png";